function EntityList(data) {
    this.list = this.createEntityList(data);
}

EntityList.prototype = Object.assign(EntityList.prototype, {
    createEntityList(rolesData) {
        return (
            rolesData &&
            rolesData.entities &&
            rolesData.entities
                .filter(entity => entity.status && entity.name)
                .map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const { name, entityCode } = row;
        return {
            name,
            value: entityCode,
        };
    },
});

export default EntityList;
